import React, { useRef, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import "../assets/css/LandingPage.css";
import cmd_logo from '../assets/images/cmd_logo.png';
import minimise from '../assets/images/minimise.PNG';
import maximise from '../assets/images/maximise.PNG';
import close from '../assets/images/close.PNG';
import recycle_bin from '../assets/images/recycle_bin.png'
import windowsxplogo from '../assets/images/windowsxplogo.png'
import cinema_clip from '../assets/images/cinema_clip.mp4'
import mouth from '../assets/images/Month.mp4'

const LandingPage = () => {
  const [inputValue, setInputValue] = useState('');
  const [historyPrompts, sethistoryPrompts] = useState([]);
  const [historyResponses, sethistoryResponses] = useState([]);
  const [awaken, setAwaken] = useState(false);
  const [speak, setSpeak] = useState(false)
  const [timestamps, setTimestamps] = useState([])
  const [currentSegment, setCurrentSegment] = useState(0);
  const videoRef = useRef(null);
  const mouthRef = useRef(null);
  const conversationHistory = useRef([]);
  const [cmudict, setCmudict] = useState({});
  
  const phonemes = {
    'AA': [0, 1.08],
    'AE': [1.08, 1.66],
    'AH': [1.66, 2.15],
    'AO': [2.71, 3.27],
    'AW': [3.27, 3.79],
    'AY': [3.79, 4.60],
    'EH': [4.60, 5.31],
    'ER': [5.31,  5.44],
    'EY': [5.44, 6.14],
    'IH': [6.14, 6.81],
    'IY': [6.81, 7.44],
    'OW': [7.44, 8.10],
    'OY': [8.10, 8.67],
    'UH': [8.67, 9.20],
    'UW': [9.20, 9.80],
    'B': [9.80, 10.44],
    'CH': [10.44, 10.96],
    'D': [10.96, 11.55],
    'DH': [11.55, 12.16],
    'F': [12.16, 12.73],
    'G': [12.73, 13.34],
    'HH': [13.34, 13.84],	
    'JH': [13.84, 14.80],
    'K': [14.80, 15.35],
    'L': [15.35, 15.96],
    'M': [15.96, 16.56],
    'N': [16.56, 17.13],
    'NG': [17.13, 17.79],
    'P': [17.79, 18.33],
    'R': [18.33, 18.82],
    'S': [18.82, 19.35],
    'SH': [19.35, 19.91],
    'T': [19.91, 20.61],
    'TH': [20.61, 21.10],
    'V': [21.10, 21.62],
    'W': [21.62, 22.12],
    'Y': [22.12, 22.67],
    'Z': [22.67, 23.25],
    'ZH': [23.25, 23.81],
  }

  // Fetch the file content when the component mounts
  useEffect(() => {
    const preprocessData = (data) => {
      const lines = data.split("\n");
      const result = {};

      lines.forEach(line => {
        // Split line into words
        const words = line.split(" ");
        
        // First word is the key
        const key = words[0];

        // Rest of the words are the value, after removing stress numbers
        const value = words.slice(1).map(word => {
          word = word.replace(/(\r\n|\n|\r)/gm, "");
          if (!isNaN(word.slice(-1))) {
            return word.replace(/[0-9]/, "")
          } else {
            return word;
          }
        }
      );

      // Assign the key-value pair to the result object
      result[key] = value;
    });

    return result;
  };
  fetch('./cmudict-0.7b.txt')
    .then(response => response.text())
    .then(data => {
      setCmudict(preprocessData(data));
    })

    .catch(err => {
      console.error('Error reading the file:', err);
    });
  }, []);


  useEffect(() => {
    const video = mouthRef.current;
    
    if (speak && timestamps.length > 0 && video) {
      document.getElementsByClassName("mouth")[0].muted = false
      const playbackRate = 1
      video.playbackRate = playbackRate
      video.volume = 1
      const playNextSegment = () => {
        if (currentSegment >= timestamps.length) return;
        const [startTime, endTime] = [timestamps[currentSegment][0] / playbackRate, timestamps[currentSegment][1] / playbackRate];
        video.currentTime = startTime;
        video.play().then(() => {
          setTimeout(() => {
            setCurrentSegment(currentSegment + 1);
          }, (endTime - startTime) * 1000);
        }).catch(error => {
          console.error("Error playing video:", error);
        });
      };
  
      playNextSegment();
  
      // Cleanup function to prevent memory leaks
      return () => video.pause();
    }
  }, [speak, timestamps, currentSegment]);

  useEffect(() => {
    const video = videoRef.current;
    
    if (awaken && video) {
      const handleVideoEnd = () => {
        // Set a different starting point (e.g., 10 seconds)
        video.currentTime = 5.35; // Change this value to your desired timestamp
        video.play();
      };

      video.addEventListener('ended', handleVideoEnd);

      // Cleanup function to remove the event listener
      return () => {
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, [awaken]);

  const sendPrompttoServer = async (prompt) => {
    try {
      const response = await fetch("http://localhost:5000/generate", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ prompt })
      })
      const data = await response.json()
      return data.response
    }
    catch (error) {
      console.error('Error:', error);
      return 'Error: Unable to contact server';
    }
  }

  const getTimestamps = (data) => {
    const lines = data.split("\n");
    const result = [];
    const phonemeArr = []

    lines.forEach(line => {
      // Split line into words
      const words = line.split(/[^aA-zZ0-9]+/);
      words.forEach((word) => {
        word = word.toUpperCase()
        while (!(word in cmudict)) {
          word = word.slice(0, -1)
        }
        cmudict[word].forEach((phoneme) => {
          if (phoneme.length > 0) {
            result.push(phonemes[phoneme])
            phonemeArr.push(phoneme)
          }
        })
      })
    })
    console.log(result)
    console.log(phonemeArr)
    return result
  }

  const handleKeyDown = async (e) => {
    if (e.key === 'Enter' && inputValue.length > 0) {
      sethistoryPrompts([...historyPrompts, inputValue]);
      const inputAsArray = inputValue.split(" ")
      const keyword = inputAsArray[0]
      let response;
      let newResponses = [...historyResponses];
      console.log(keyword)
      switch(keyword) {
        case "echo":
          inputAsArray.shift();
          if (awaken) {
            const timestamps = []
            inputAsArray.map((word) => {
              word = word.toUpperCase()
              while (!(word in cmudict)) {
                word = word.slice(0, -1)
              }
              cmudict[word].forEach((phoneme) => {
                if (phoneme.length > 0) {
                  timestamps.push(phonemes[phoneme])
                }
              })
            })
            setSpeak(true)
            setTimestamps(timestamps)
            setCurrentSegment(0)
          }
          sethistoryResponses([...historyResponses, [inputAsArray.join(" ")]]);
          console.log(historyPrompts)
          console.log(historyResponses)
          console.log(cmudict)
          break;
        case("help"):
          const helpMessage = [
            'ECHO: Displays messages, or turns command echoing on or off.',
            'HELP: Provides Help information for Pikastunner\'s commands.',
            'CLEAR: Deletes history from terminal.',
            'AWAKE: Pikastunner awakes from his slumber. Enter awake.',
            'SLEEP: Pikastunner falls asleep. Enter sleep.',
            'TEXT: Communicate with Pikastunner through text chat and he will respond through text. For example, text hello how are you. You must wake Pikastunner up before speaking to him.',
            'SPEAK: Communicate with Pikastunner through text chat and and he will respond through speech and text. For example, speak hello how are you. You must wake Pikastunner up before speaking to him.'
          ]
          sethistoryResponses([...historyResponses, helpMessage])
          break;
        case("awake"):
          if (!awaken) {
            response = "Pikastunner arises from his slumber."
            changeBackgroundLighting(false)
            setAwaken(true)
          }
          else {
            response = "Pikastunner is awake."
          }
          sethistoryResponses([...historyResponses, [response]])
          break;
        case("sleep"):
          if (awaken) {
            response = "Pikastunner begins his slumber."
            changeBackgroundLighting(true)
            setAwaken(false)
            setSpeak(false)
          }
          else {
            response = "Pikastunner is asleep."
          }
          sethistoryResponses([...historyResponses, [response]])
          break;
        case("text"):
          if (!awaken) {
            response = "Pikastunner is not awake."
            sethistoryResponses([...historyResponses, [response]])
          }
          else {
            inputAsArray.shift();
            const prompt = inputAsArray.join(" ")
            newResponses = [...newResponses, ["Processing..."]];
            setInputValue('');
            document.getElementsByClassName("placeholder")[0].innerHTML = "_";
            document.getElementsByClassName("placeholder")[1].innerHTML = "";
            sethistoryResponses(newResponses);
            console.log(conversationHistory)
            response = conversationHistory.current.length === 0 ? await sendPrompttoServer(prompt) : 
            await sendPrompttoServer(conversationHistory.current.join("\n") + '\n' + prompt)
            conversationHistory.current.push(prompt)
            conversationHistory.current.push(response)
            console.log(response)
            newResponses[newResponses.length - 1] = [response];
            sethistoryResponses([...newResponses])
          }
          break;
        case("speak"):
          if (!awaken) {
            response = "Pikastunner is not awake."
            sethistoryResponses([...historyResponses, [response]])
          }
          else {
            inputAsArray.shift();
            const prompt = inputAsArray.join(" ")
            newResponses = [...newResponses, ["Processing..."]];
            setInputValue('');
            document.getElementsByClassName("placeholder")[0].innerHTML = "_";
            document.getElementsByClassName("placeholder")[1].innerHTML = "";
            sethistoryResponses(newResponses);
            console.log(conversationHistory)
            response = conversationHistory.current.length === 0 ? await sendPrompttoServer(prompt) : 
            await sendPrompttoServer(conversationHistory.current.join("\n") + '\n' + prompt)
            setSpeak(true)
            setTimestamps(getTimestamps(response))
            conversationHistory.current.push(prompt)
            conversationHistory.current.push(response)
            console.log(response)
            newResponses[newResponses.length - 1] = [response];
            sethistoryResponses([...newResponses])
            setCurrentSegment(0)
          }
          break;
        case("clear"):
          sethistoryResponses([]) 
          sethistoryPrompts([])
          conversationHistory.current = []
          break;
        default:
          sethistoryResponses([...historyResponses, []]);
          break;
      }
      setInputValue('');
      document.getElementsByClassName("placeholder")[0].innerHTML = "_";
      document.getElementsByClassName("placeholder")[1].innerHTML = "";
    }
  }

  const changeBackgroundLighting = (reverse) => {
    if (!reverse) {
      document.getElementsByClassName("cinema")[0].style.border = "5vh solid grey"
      document.getElementById("seats").classList.remove('seats')
      document.getElementById("seats").classList.add('lighted-seats')
    }
    else {
      document.getElementsByClassName("cinema")[0].style.border = "5vh solid #0b0704"
      document.getElementById("seats").classList.remove('lighted-seats')
      document.getElementById("seats").classList.add('seats')
    }
  }

  const formatAMPM = date => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  };
  
  const [time, setTime] = useState(formatAMPM(new Date()));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(formatAMPM(new Date()));
    }, 1000);

    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);

  function getScrollbarWidth() {
    // Create a temporary div element
    const div = document.createElement('div');
  
    // Apply styles to force a scrollbar
    div.style.width = '100px';
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    div.style.top = '-9999px'; // Position off-screen
  
    // Append the div to the body
    document.body.appendChild(div);
  
    // Measure the scrollbar width
    const scrollbarWidth = div.offsetWidth - div.clientWidth;
  
    // Remove the temporary div from the body
    document.body.removeChild(div);
  
    // Return the scrollbar width
    return scrollbarWidth;
  }
  
  function getPxFromVw(vw) {
    return (vw / 100) * window.innerWidth;
  }
  
  function getPxFromCh() {
    const tempSpan = document.createElement('span');
    tempSpan.style.font = 'inherit'; // Use the same font as the document
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'pre';
    tempSpan.textContent = '0';
    document.body.appendChild(tempSpan);
    const chWidth = tempSpan.offsetWidth;
    document.body.removeChild(tempSpan);
    return chWidth;
  }
  
  function vwToCh(vw) {
    const pxInVw = getPxFromVw(vw);
    const pxInCh = getPxFromCh();
    return pxInVw / pxInCh;
  }
  
  const updateInput = (e) => {
    if (e.target.value.length > 0) {
      document.getElementsByClassName("placeholder")[0].innerHTML = "";
      document.getElementsByClassName("placeholder")[1].innerHTML = "_";
      document.getElementById("input").style.width = `${e.target.value.length}ch`
      //vwToCh(40) > e.target.value.length ? document.getElementById("input").style.width = `${e.target.value.length}ch` : document.getElementById("input").style.width = `${vwToCh(40)}ch`; 
    }
    else {
      document.getElementsByClassName("placeholder")[0].innerHTML = "_";
      document.getElementsByClassName("placeholder")[1].innerHTML = "";
    }
    const string = e.target.value
    setInputValue(string)
    console.log(inputValue)
    console.log(inputValue.length)
  }

  return (
    <div className='entire-container'>
      <Helmet>
        <title>Welcome to PIKASTUNNER</title>
      </Helmet>
      <div className='left-side'>
        <div className='cinema animation1 animation2'>
          {awaken && <video ref={videoRef} className='clip' src={cinema_clip} autoPlay muted></video>}
          {speak && <video ref={mouthRef} className='mouth' src={mouth + '#t=6'} muted></video>}
        </div>
        <div id='seats' className='seats'>
        </div>
      </div>
      <div className='right-side'>
        <div className='main-right'>
          <img src={recycle_bin} className='recycle'></img>
          <div className='caption'>Recycle Bin</div>
          <div className='terminal'>
            <nav className='nav-bar'>
             <div className='left-nav'> 
                <img src={cmd_logo} className='logo'></img>
                <p>
                  C:\PIKASTUNNER\system32\cmd.exe
                </p>
              </div>
              <div className='windows-controls'>
                <img src={minimise}></img>
                <img src={maximise}></img>
                <img src={close}></img>
              </div>
            </nav>
            <div className='command-prompt'>
              <b>
                Pikastunner System [Version 1.0]
              </b>
              <b>
                Welcome to pikastunnerSpeak. This is a mock simulation of Pikastunner's intelligence. Enter help to obtain the list of available commands.
              </b>
              <br></br>
              {historyPrompts.map((prompt, index) => {  
                if (prompt.length === 0) {
                  return (
                    <div>
                      <div className='current-line'>
                        <b>
                          C:\Users\User{'>'}{prompt}
                        </b>
                      </div>
                    </div>
                  );
                }  
                else {
                  return (
                    <div>
                      <div className='current-line'>
                        <b>
                          C:\Users\User{'>'}{prompt}
                        </b>
                      </div>
                      {historyResponses[index]?.map((iter) => {
                        return (
                          <div>
                            <b>
                              {iter}
                            </b>
                          </div>
                        )
                      })}
                    </div>
                  );
                }
              })}
              <div className='current-line'>
                <b>
                  C:\Users\User{'>'}
                </b>
                <div className='text-container'>
                  <span className='placeholder'>_</span>
                  <input id="input" type="text" onKeyDown={handleKeyDown} value={inputValue} onChange={updateInput} spellCheck="false"/>
                  <span className='placeholder'></span>
                </div>
              </div>
            </div>
          </div>
          <div className='taskbar'>
            <div className='start'><img src={windowsxplogo} className='windowsxplogo'></img>start</div>
            <div className='right-half-taskbar'>
              <div className='cmd-taskbar'>
                <img src={cmd_logo} className='logo'></img>
                C:\PIKASTUNNER\system32\cmd.exe
              </div>
              <div className='time'>{time}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;